import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import { Terminal } from './components/Terminal/Terminal'

const EventPage = lazy(() => import('./pages/event/EventPage').then(module => ({ default: module.EventPage })))
const CVPage = lazy(() => import('./pages/cv/CVPage').then(module => ({ default: module.CVPage })))
const HolidayPage = lazy(() => import('./pages/holiday/HolidayPage').then(module => ({ default: module.HolidayPage })))

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Terminal />} />
        <Route
          path="/event"
          element={
            <Suspense fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>Loading event...</div>}>
              <EventPage />
            </Suspense>
          }
        />
        <Route
          path="/cv"
          element={
            <Suspense fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>Loading CV...</div>}>
              <CVPage />
            </Suspense>
          }
        />
        <Route
          path="/holiday"
          element={
            <Suspense fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>Loading countdown...</div>}>
              <HolidayPage />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
